module.exports = __webpack_public_path__ + "img/search.0c1203ae.svg";